<!-- Header -->
<div style="display: flex; flex-direction: column;">

	<!-- Head Text and Search -->
	<div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
		<h3 mat-dialog-title *ngIf="isStudentSearch">
			Saved Filters
		</h3>
		<h3 mat-dialog-title *ngIf="!isStudentSearch">
			Saved Queries
		</h3>
		<div>
			<tyl-form-field style="width: 320px">
				<input matInput type="text" name="Search Queries" id="availableFieldsField" [(ngModel)]="querySearch"
					(keydown)="$event.key.toLowerCase() == 'enter' ? applySearch() : null" (blur)="applySearch()">
			</tyl-form-field>
			<button style="background-color: inherit; border: none;" (click)="applySearch()">
				<img src="./assets/images/search normal.png" alt="Search" title="Search"
					style="width: 25px; height: 25px;" />
			</button>
		</div>
	</div>
</div>

<!-- Body -->
<mat-dialog-content style="height: 65vh; width: calc(80vw - 10px);">

	<!-- Table -->
	<mat-table [dataSource]="tableData" matSort matSortDisableClear matSortActive="QueryName" matSortDirection="asc"
		multiTemplateDataRows>

		<!-- More Column -->
		<ng-container matColumnDef="more">
			<mat-header-cell *matHeaderCellDef translate>
				More
			</mat-header-cell>
			<mat-cell *matCellDef="let query">
				<span *ngIf="hasDetailRow(query)" class="material-icons" [ngClass]="{
						'detail-row-expanded-icon': tableData.checkExpanded(query),
						'detail-row-collapsed-icon': !tableData.checkExpanded(query)
					}"></span>
			</mat-cell>
		</ng-container>

		<!-- Name Column -->
		<ng-container matColumnDef="name">
			<mat-header-cell *matHeaderCellDef mat-sort-header="QueryName" #nameHeader translate>
				Name
			</mat-header-cell>
			<mat-cell *matCellDef="let query">
				<a (click)="selectQuery(query); $event.stopPropagation();">
					{{query.QueryName}}
				</a>
			</mat-cell>
		</ng-container>

		<!-- Scope Column -->
		<ng-container matColumnDef="scope">
			<mat-header-cell *matHeaderCellDef translate>
				Scope
			</mat-header-cell>
			<mat-cell *matCellDef="let query">
				{{query.Scope}}
			</mat-cell>
		</ng-container>

		<!-- Owner Column -->
		<ng-container matColumnDef="owner">
			<mat-header-cell *matHeaderCellDef translate>
				Owner
			</mat-header-cell>
			<mat-cell *matCellDef="let query">
				{{query.OwnerName}}
			</mat-cell>
		</ng-container>

		<!-- Available to Integration Services -->
		<ng-container matColumnDef="published">
			<mat-header-cell *matHeaderCellDef translate>
				<span style="text-align: center">
					Available to <br /> Integration Services
				</span>
			</mat-header-cell>
			<mat-cell *matCellDef="let query">
				{{query.Published ? 'Y' : ''}}
			</mat-cell>
		</ng-container>

		<!-- Last Updated Column -->
		<ng-container matColumnDef="last-updated">
			<mat-header-cell *matHeaderCellDef translate>
				Last Updated
			</mat-header-cell>
			<mat-cell *matCellDef="let query">
				{{query.LastUpdated | date: 'MM/dd/yy'}}
			</mat-cell>
		</ng-container>

		<!-- Actions Column -->
		<ng-container matColumnDef="actions">
			<mat-header-cell *matHeaderCellDef translate>
				Actions
			</mat-header-cell>
			<mat-cell *matCellDef="let query">
				<tyl-mat-menu image="actions.png" [showLabel]="false" (click)="$event.stopPropagation()"
					[topMenuItems]="getMenuItems(query)" [data]="query" (menuClick)="menuItemClick($event)">
				</tyl-mat-menu>
			</mat-cell>
		</ng-container>

		<!-- Expand Row -->
		<ng-container matColumnDef='expanded-row'>
			<td mat-cell class="mat-detail-card" *matCellDef="let query" [attr.colspan]="6">
				<ng-container *ngIf="query.Description">
					<div style="color: gray">
						Description
					</div>
					<div>
						{{query.Description}}
					</div>
				</ng-container>
				<div *ngIf="query.Description && query.SelectedSites && query.Scope == 'Selected Sites'">
					&nbsp;
				</div>
				<ng-container *ngIf="query.SelectedSites && query.Scope == 'Selected Sites'">
					<div style="color: gray">
						Selected Sites
					</div>
					<div>
						{{query.SelectedSiteNames}}
					</div>
				</ng-container>
			</td>
		</ng-container>

		<!-- Row Definitions -->
		<mat-header-row *matHeaderRowDef="columns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: columns;" matRipple tabindex="0" [ngStyle]="{
				'cursor': hasDetailRow(row) ? 'pointer' : ''
			}" [ngClass]="{'detailRowOpened': hasDetailRow(row) && tableData.checkExpanded(row)}"
			(click)="hasDetailRow(row) ? tableData.toggleExpanded(row) : null"></mat-row>
		<mat-row *matRowDef="let row; columns: ['expanded-row']" class="mat-detail-row"
			[@detailExpand]="hasDetailRow(row) && tableData.checkExpanded(row) ? 'expanded' : 'collapsed'"
			style="overflow: hidden"></mat-row>
	</mat-table>

</mat-dialog-content>
<div style="display: flex; flex-direction: column;">
	<!-- Paginator -->
	<mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="initialPageSize"></mat-paginator>
</div>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">

	<!-- Left Buttons -->
	<expand-collapse-buttons [expandEmitter]="expandEmitter"></expand-collapse-buttons>

	<!-- Right Buttons -->
	<div class="footerRight">
		<tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancel()"></tyl-button>
	</div>
</mat-dialog-actions>